exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canvasAreaPreview{transform:translate(-50%,-50%);left:50%;top:50%;position:absolute;z-index:999}.labelsContainer .svgPreview .pages{position:absolute!important;top:-15000px!important;left:-15000px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b234396","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Canvas/Canvas.vue
// module id = 84
// module chunks = 0